export const getFileNameWithoutExtension = (fileName: string) => {
	const dotIndex = fileName.lastIndexOf('.');
	return dotIndex === -1 ? fileName : fileName.substring(0, dotIndex);
};
